import { capitalize, escapeRegExp } from 'lodash-es';
import { removeStopwords } from 'stopword';

export const removeAllSpaces = (text: string) => {
  return text.replace(/\s/g, '');
};

export const uncapitalize = (text: string) => {
  return `${text[0].toLowerCase()}${text.slice(1)}`;
};

export const replaceSubstring = (originalString: string, start: number, end: number, newSubstring: string) => {
  return originalString.slice(0, start) + newSubstring + originalString.slice(end);
};

// Create a function to filter out objects with similar names
export const filterSimilarNames = (arr: { name: string; value: string }[]) => {
  const uniqueNames = new Set();
  return arr.filter((obj) => {
    if (!uniqueNames.has(obj.name)) {
      uniqueNames.add(obj.name);
      return true;
    }
    return false;
  });
};

export const separateTextByLineBreaks = (text: string) => {
  return text.replace(/\n+/g, '\n').split('\n');
};

export const sortAlphabetically = (textA: string, textB: string) => {
  return textA.localeCompare(textB);
};

export const matchWords = (sourceText: string, textToMatch: string, matchWholeWords = true) => {
  const regex = matchWholeWords
    ? new RegExp(`\\b${escapeRegExp(textToMatch)}\\b`, 'i')
    : new RegExp(escapeRegExp(textToMatch), 'i');

  return regex.test(sourceText);
};

export const removeEnglishStopwords = (texts: string[]) => {
  return removeStopwords(texts);
};

export const singularOrPlural = (singular: string, plural: string) => (count?: number | null) => {
  if (typeof count !== 'number') return singular;

  if (Math.abs(count) === 1) return singular;

  return plural;
};

export const snakeCaseToDisplayText = (text: string) => {
  return text.split('_').map(capitalize).join(' ');
};

export const getDomainFromEmail = (email: string) => {
  return email.split('@')[1];
};

export const pascalCaseWithSpaces = (text: string) => {
  return text.replace(/([A-Z])/g, ' $1').trim();
};

export const extractPercentNumber = (text: string) => {
  return text.match(/(\d+(\.\d+)?)%/)?.[1];
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const removeLineBreaks = (text: string, replacer = '') => {
  return text.replace(/\n/g, replacer);
};

export const removeSpecialChars = (text: string, replacer = '') => {
  return text.replace(/[^A-Z0-9]+/gi, replacer);
};

export const isEmail = (text: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const hasConsecutiveDots = /\.{2,}/.test(text);

  return emailRegex.test(text) && !hasConsecutiveDots;
};

export const hasLowercaseLetter = (text: string) => {
  return /[a-z]/.test(text);
};

export const hasUppercaseLetter = (text: string) => {
  return /[A-Z]/.test(text);
};

export const hasSpecialChar = (text: string) => {
  return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(text);
};

export const isNumber = (text: string) => {
  return /^\d*$/.test(text);
};

export const lowercaseSearch = (text: string, search: string) => {
  return text.toLowerCase().includes(search.toLowerCase());
};
